module.exports = __webpack_public_path__ + "img/IMAGE02.ff4c2672.jpeg";